import { render, staticRenderFns } from "./ImageGalleryHeader.vue?vue&type=template&id=e4bfb30a&"
import script from "./ImageGalleryHeader.vue?vue&type=script&lang=ts&"
export * from "./ImageGalleryHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports